<template>
  <!-- 保留两位小数的输入框 -->
  <div id="decimalNumInput">
    <el-input @focus="handleFocus" @change="handleChange" v-model="localDecimalNum"></el-input>
  </div>
</template>

<script >
const DECIMAL_NUM_REG = /(^[1-9]([0-9]{1,7})?(\.[0-9]+)$)|(^[1-9]([0-9]{0,7})$)|(^(0){1}$)|(^[0-9]\.[0-9]+$)/;
export default {
  props: {
    // 动态表单数据的下标
    updateIndex: {
      type: Number,
      default: 0,
    },
    decimalNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      localDecimalNum: this.decimalNum,
    };
  },
  watch: {
    decimalNum: {
      handler(newVal) {
        this.localDecimalNum = newVal;
      },
    },
  },
  methods: {
    // 如果是动态生成的表单数据，那么需要记录当前更新的是哪条数据，也就是需要记录index
    handleFocus() {
      this.$emit("update", this.updateIndex);
    },
    // 过滤值
    handleChange(val) {
      let isEffectiveNum = DECIMAL_NUM_REG.test(Number(val));
      isEffectiveNum
        ? (val = DECIMAL_NUM_REG.exec(val).shift() || 1)
        : (val = 1);
      val = Math.floor(Number(val) * 100) / 100;
      this.localDecimalNum = val;
      this.$emit("complete", val);
    },
  },
};
</script>

<style lang="scss">
#decimalNumInput {
  .el-input {
    .el-input__inner {
      height: 32px;
      background: rgba(234, 238, 245, 0.2);
      border-radius: 4px;
      border: 1px solid rgba(234, 238, 245, 1);
    }
    .el-input__inner:hover {
      border-color: rgba(192, 196, 204, 1);
    }
    .el-input__inner:focus {
      border-color: rgba(61, 116, 242, 1);
    }
    .el-input__suffix {
      height: 40px;
      top: -3px;
      right: 0px;
      cursor: pointer;
    }
  }
}
</style>
